import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Countries",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getCountries, getCountriesError, getCountriesSuccess } =
  slice.actions;

reducerRegistry.register("countries", reducer);
